module.exports = __webpack_public_path__ + "static/media/address-additional-address-field.ab1193e9.png";